import { FiSearch } from "react-icons/fi";
import Input from "@components/Input";

export function PTOFilters({
  plants,
  plantFilter,
  onPlantChange,
  statusFilter,
  onStatusChange,
  viewMode,
  onViewModeChange,
  onOpenBlockedModal,
  searchVal,
  onSearchChange,
  isMobile,
  requestPeriodEnabled,
  onRequestPeriodEnabledChange,
  requestPeriodStart,
  onRequestPeriodStartChange,
  requestPeriodEnd,
  onRequestPeriodEndChange,
  ptoDatesEnabled,
  onPtoDatesEnabledChange,
  ptoDatesStart,
  onPtoDatesStartChange,
  ptoDatesEnd,
  onPtoDatesEndChange,
}: {
  plants: any[];
  plantFilter: string;
  onPlantChange: (plantId: string) => void;
  statusFilter: string;
  onStatusChange: (status: string) => void;
  viewMode: string;
  onViewModeChange: (mode: string) => void;
  onOpenBlockedModal?: () => void;
  searchVal?: string;
  onSearchChange?: (val: string) => void;
  isMobile?: boolean;
  requestPeriodEnabled?: boolean;
  onRequestPeriodEnabledChange?: (enabled: boolean) => void;
  requestPeriodStart?: string;
  onRequestPeriodStartChange?: (date: string) => void;
  requestPeriodEnd?: string;
  onRequestPeriodEndChange?: (date: string) => void;
  ptoDatesEnabled?: boolean;
  onPtoDatesEnabledChange?: (enabled: boolean) => void;
  ptoDatesStart?: string;
  onPtoDatesStartChange?: (date: string) => void;
  ptoDatesEnd?: string;
  onPtoDatesEndChange?: (date: string) => void;
}) {
  return (
    <div className="tw-bg-white dark:tw-bg-[#0D1117] tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-p-2 tw-mb-2">
      <div className="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between tw-gap-2">
        <div className="tw-flex tw-flex-col tw-gap-1 md:tw-flex-row md:tw-items-center md:tw-gap-1 md:tw-flex-wrap">
          {onSearchChange && (
            <div className="tw-w-full md:tw-w-48">
              <Input
                icon={FiSearch}
                containerStyle={{
                  marginRight: 0,
                  width: "100%",
                  height: isMobile ? 24 : 28,
                }}
                id="pto-search"
                type="text"
                name="search"
                placeholder="search"
                onChange={(e: any) => onSearchChange(e.target.value)}
                disabled={false}
                value={searchVal || ""}
              />
            </div>
          )}
          <div className="tw-flex tw-items-center tw-gap-1 tw-w-full md:tw-w-auto">
            <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
              Plant:
            </label>
            <select
              value={plantFilter}
              onChange={(e) => onPlantChange(e.target.value)}
              className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827]"
            >
              <option value="0">All</option>
              {plants.map((plant) => (
                <option key={plant.id} value={plant.id}>
                  {plant.name}
                </option>
              ))}
            </select>
          </div>

          <div className="tw-flex tw-items-center tw-gap-1 tw-w-full md:tw-w-auto">
            <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
              Status:
            </label>
            <select
              value={statusFilter}
              onChange={(e) => onStatusChange(e.target.value)}
              className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827]"
            >
              <option value="">All</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="balance_overridden">Balance_Overridden</option>
              <option value="rejected">Rejected</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>

          {/* Request Period Filter - Inline */}
          {onRequestPeriodEnabledChange && (
            <div className="tw-flex tw-items-center tw-gap-1 tw-flex-wrap tw-w-full md:tw-w-auto md:tw-ml-4">
              <div className="tw-flex tw-items-center tw-gap-0.5">
                <label
                  htmlFor="request-period-filter"
                  className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300 tw-cursor-pointer"
                >
                  Requested:
                </label>
                <input
                  type="checkbox"
                  id="request-period-filter"
                  checked={requestPeriodEnabled || false}
                  onChange={(e) =>
                    onRequestPeriodEnabledChange(e.target.checked)
                  }
                  className="tw-w-3 tw-h-3 tw-mr-1"
                />
              </div>
              {requestPeriodEnabled &&
                onRequestPeriodStartChange &&
                onRequestPeriodEndChange && (
                  <>
                    <input
                      type="date"
                      value={requestPeriodStart || ""}
                      onChange={(e) =>
                        onRequestPeriodStartChange(e.target.value)
                      }
                      className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827] tw-w-24"
                    />
                    <span className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
                      to
                    </span>
                    <input
                      type="date"
                      value={requestPeriodEnd || ""}
                      onChange={(e) => onRequestPeriodEndChange(e.target.value)}
                      className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827] tw-w-24"
                    />
                  </>
                )}
            </div>
          )}

          {/* PTO Dates Filter - Inline */}
          {onPtoDatesEnabledChange && (
            <div className="tw-flex tw-items-center tw-gap-1 tw-flex-wrap tw-w-full md:tw-w-auto md:tw-ml-4">
              <div className="tw-flex tw-items-center tw-gap-0.5">
                <label
                  htmlFor="pto-dates-filter"
                  className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300 tw-cursor-pointer"
                >
                  PTO:
                </label>
                <input
                  type="checkbox"
                  id="pto-dates-filter"
                  checked={ptoDatesEnabled || false}
                  onChange={(e) => onPtoDatesEnabledChange(e.target.checked)}
                  className="tw-w-3 tw-h-3 tw-mr-1"
                />
              </div>
              {ptoDatesEnabled &&
                onPtoDatesStartChange &&
                onPtoDatesEndChange && (
                  <>
                    <input
                      type="date"
                      value={ptoDatesStart || ""}
                      onChange={(e) => onPtoDatesStartChange(e.target.value)}
                      className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827] tw-w-24"
                    />
                    <span className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
                      to
                    </span>
                    <input
                      type="date"
                      value={ptoDatesEnd || ""}
                      onChange={(e) => onPtoDatesEndChange(e.target.value)}
                      className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827] tw-w-24"
                    />
                  </>
                )}
            </div>
          )}
        </div>
        <div className="tw-flex tw-items-center tw-gap-1">
          <button
            className={`tw-px-2 tw-py-0.5 tw-rounded-md tw-text-[12px] tw-min-w-[9ch] tw-border ${
              viewMode === "table"
                ? "tw-bg-blue-600 tw-text-white tw-border-blue-600"
                : "tw-bg-white dark:tw-bg-[#111827] tw-text-gray-700 dark:tw-text-gray-200 tw-border-gray-300 dark:tw-border-gray-700"
            }`}
            onClick={() => onViewModeChange("table")}
          >
            Table
          </button>
          <button
            className={`tw-px-2 tw-py-0.5 tw-rounded-md tw-text-[12px] tw-min-w-[9ch] tw-border ${
              viewMode === "calendar"
                ? "tw-bg-blue-600 tw-text-white tw-border-blue-600"
                : "tw-bg-white dark:tw-bg-[#111827] tw-text-gray-700 dark:tw-text-gray-200 tw-border-gray-300 dark:tw-border-gray-700"
            }`}
            onClick={() => onViewModeChange("calendar")}
          >
            Calendar
          </button>
        </div>
      </div>
    </div>
  );
}
